import React from "react";
import { Typography, TypographyProps } from "@material-ui/core";
import { InlineType } from "../InlineType";

export const ColumnHeading: React.FC<TypographyProps> = ({
  children,
  ...props
}) => {
  return (
    <Typography
      variant="body2"
      component="span"
      color="textSecondary"
      {...props}
    >
      <InlineType fontWeight={700}>{children}</InlineType>
    </Typography>
  );
};
